import axios from "axios";

const API_BASE = "/api/contact-images";

/**
 * Contact images API – store and load images per contact in the database
 */
const getImagesByContact = async (contactId) => {
  const res = await axios.get(`${API_BASE}/contact/${contactId}`, { withCredentials: true });
  return res.data;
};

/**
 * Replace all images for a contact (clear + save). Payload: { images: [{ fileUrl, fileName }] }
 */
const replaceImages = async (contactId, images) => {
  const res = await axios.put(
    `${API_BASE}/contact/${contactId}`,
    { images },
    { withCredentials: true, headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

/**
 * Save additional images for a contact. Payload: { contactId, images: [{ fileUrl, fileName }] }
 */
const saveImages = async (contactId, images) => {
  const res = await axios.post(
    API_BASE,
    { contactId, images },
    { withCredentials: true, headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

/**
 * Clear all images for a contact
 */
const clearImages = async (contactId) => {
  const res = await axios.delete(`${API_BASE}/contact/${contactId}`, { withCredentials: true });
  return res.data;
};

/**
 * Delete one image by id
 */
const deleteImage = async (imageId) => {
  const res = await axios.delete(`${API_BASE}/${imageId}`, { withCredentials: true });
  return res.data;
};

const contactImageService = {
  getImagesByContact,
  replaceImages,
  saveImages,
  clearImages,
  deleteImage,
};
export default contactImageService;
